module.exports = __webpack_public_path__ + "media/images/error-1c11ac42c08ceba98939a8a0371f47c9.mp3";